export default {
  inject: {
    getPricing: { default: () => () => ({}) },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return validated && !valid ? false : null;
    },
    getOptionPrice(option) {
      // V2 Forms: price directly on option
      if (option.price != null) {
        return String(option.price);
      }

      // V3 Forms: lookup from pricing rules
      if (option.use_pricing) {
        const pricing = this.getPricing();
        const rule = pricing[option.use_pricing];
        if (rule?.amount != null) {
          return rule.amount;
        }
      }

      return null;
    },
    formatOptionPrice(option) {
      const price = this.getOptionPrice(option);
      if (!price) return null;

      const priceStr = String(price);
      return priceStr.startsWith("$") ? priceStr : `$${priceStr}`;
    },
  },
};
